import { useEffect, useState, useCallback, useRef } from "react";
import styles from "./ageSelectionPage.module.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ImgBuilder from "../../assets/ImgBuilder";

import AppBar from "../../components/appBar/appBar";
import AbortGame from "../../components/abortGame/abortGame";

import BoxAge from "../../components/boxSettings/boxAge";

import { useUserData } from '../../functions/updateUserData';

const TEEN_GROUP = ["10-12", "13-15", "16-17"]; // ["13-15","16-17"]

const AgeSelectionPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [userAgeGroup, setUserAgeGroup] = useState("");
  const hasRunRef = useRef(false);
  
  const { setUserData } = useUserData();

  const ageGroups = [
    "10-12",
    "13-15",
    "16-17",
    "18-24",
    "25-34",
    "35-44",
    "45-54",
    "55-64",
    "over 64"
  ];
  const imagesAdded = {
    "10-12": ImgBuilder.flowerIcon,
    "55-64": ImgBuilder.tobaccoIcon,
    "35-44": ImgBuilder.runningIcon,
  };

  // const teenGroup = ["10-12", "13-15","16-17"] // ["13-15","16-17"]
  // const lowerTeenGroup = ["10-12"]

  const nextStep = useCallback(() => {
    if (hasRunRef.current) return;
    hasRunRef.current = true;

    setUserData(prev => ({
      ...prev,
      age_group: userAgeGroup,
    }));

    if (TEEN_GROUP.includes(userAgeGroup)) {
      navigate("/social");
    } // else if (lowerTeenGroup.includes(userAgeGroup)){
    //   navigate("/story");
    // }
    else {
      navigate("/data");
    }
  }, [userAgeGroup, navigate, setUserData]);

  useEffect(() => {
    if (userAgeGroup){
      nextStep();
    }
  }, [userAgeGroup, nextStep]);


  return (
    <div className={styles.wrapperLogin}>
      <AppBar />
      <AbortGame />
      <img alt="bg" className={styles.bgImg} src={ImgBuilder.sbBackground}/>
      <p className={styles.pageName}>{t("setup.select_age")}</p>

      <BoxAge
        handleCompletion={setUserAgeGroup}
        hdelay={"20ms"}
        imagesAdded={imagesAdded}
        ageQuestion={t("setup.select_age_question")}
        ageWord={t("setup.age_word")}
        settingsOptionsAge={ageGroups}
      />

    </div>
  );
};

export default AgeSelectionPage;
